module.exports = __webpack_public_path__ + "img/right01-6.2e008395.png";